// Webpack Imports
import * as bootstrap from "bootstrap";
import lactalis from "./lactalis";
(function ($) {
  "use strict";

  // Cookies
  lactalis.createCookies();

  // Buttons events
  lactalis.btnLactalis();

  // Change individual cookie selection
  lactalis.updateCookieSelection();

  $("#cookie_preferences").on("save.bs.cookiePreferences", function () {
    $("#cookie_preferences").modal("hide");
    lactalis.createCookies();
  });

  $("#CookiePreferenceDialogBodyButtonDecline").on("click", function () {
    // ocultar modal
    $("#cookie_preferences").modal("toggle");

    // Actualiza las preferencias de cookies a false
    var updatedPreferences = {
      functionality: false,
      analysis: false,
      advertising: false,
    };

    // Calcula la fecha de expiración en 401 días a partir de hoy
    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 401);

    // Guardamos la cookie directamente
    document.cookie =
      "cookies.preferences=" +
      JSON.stringify(updatedPreferences) +
      "; expires=" +
      expirationDate.toUTCString() +
      "; path=/;";

    // Marcamos los checkbox como falsos por si reabre el modal sin recargar la página
    $("#CookiePreferenceDialogBodyLevelButtonFuncionality").prop(
      "checked",
      false
    );
    $("#CookiePreferenceDialogBodyLevelButtonPerformance").prop(
      "checked",
      false
    );
    $("#CookiePreferenceDialogBodyLevelButtonAdvertising").prop(
      "checked",
      false
    );
  });

  $("#CookiePreferenceDialogBodyShowConfigurationTab").on("click", function () {
    // mostrar tab Configuracion
    $("#CookiePreferenceDialogNavDetails").tab("show");

    // - Hide Configuration Button
    $("#CookiePreferenceDialogBodyShowConfigurationTab").addClass("hide");

    // - Show Permit selection Button
    $(
      "#CookiePreferenceDialogBodyLevelButtonLevelOptinAllowallSelection"
    ).removeClass("hide");
  });

  $(".cookies_configuration a").on("click", function () {
    $("#cookie_preferences").modal("toggle");
  });

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
})(jQuery);

global.lactalis = lactalis;
